// extracted by mini-css-extract-plugin
export var rule = "Footer-module--rule--Ywm_f";
export var list = "Footer-module--list--2LLaq";
export var container = "Footer-module--container--vsDRR";
export var heading = "Footer-module--heading--hlE-e";